import { Tooltip } from '@blueprintjs/core';
import { Tag } from '@blueprintjs/core';
import { formatDatetime } from '../../../utils/formatDate';
import { followUpIsNow } from './followUpIsNow';
import cardClasses from '../CommunicationItem/Card.module.css';

export function FollowupTag({
  followupAt,
  resolvedAt,
}: {
  followupAt: string | undefined;
  resolvedAt: string | undefined;
}) {
  return (
    <div className={cardClasses.tags}>
      {resolvedAt && (
        <Tooltip
          content={
            <span>
              Resolved at <span>{formatDatetime(resolvedAt)}</span>
            </span>
          }
        >
          <Tag intent="success" minimal>
            Resolved
          </Tag>
        </Tooltip>
      )}
      {followupAt && !resolvedAt && (
        <Tooltip
          disabled={!followUpIsNow(followupAt, resolvedAt)}
          content="Followup time has expired. Please follow up now."
        >
          <Tag
            minimal
            intent={followUpIsNow(followupAt, resolvedAt) ? 'warning' : 'none'}
          >
            Followup: <span>{formatDatetime(followupAt)}</span>
          </Tag>
        </Tooltip>
      )}
    </div>
  );
}
